import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CompCtx = createContext(null);

export function CompetitionProvider({ children }) {
  const { user } = useAuth();
  const [competitions, setCompetitions] = useState([]);
  const [currentId, setCurrentId] = useState(
    localStorage.getItem("current_competition_id") || null
  );
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user || user === false) return;
    setLoading(true);
    try {
      const { data } = await api.get("/competitions");
      setCompetitions(data);
      setCurrentId((prevId) => {
        if (data.length === 0) {
          localStorage.removeItem("current_competition_id");
          return null;
        }
        if (!prevId && data.length > 0) {
          localStorage.setItem("current_competition_id", data[0].id);
          return data[0].id;
        }
        if (prevId && !data.find((c) => c.id === prevId) && data.length > 0) {
          localStorage.setItem("current_competition_id", data[0].id);
          return data[0].id;
        }
        return prevId;
      });
    } catch (e) {
      console.warn("Failed to load competitions:", e?.message);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (user && user !== false) refresh();
  }, [user, refresh]);

  const setCurrent = useCallback((id) => {
    setCurrentId(id);
    localStorage.setItem("current_competition_id", id);
  }, []);

  const current = useMemo(
    () => competitions.find((c) => c.id === currentId) || null,
    [competitions, currentId]
  );

  const value = useMemo(
    () => ({ competitions, current, currentId, setCurrent, refresh, loading }),
    [competitions, current, currentId, setCurrent, refresh, loading]
  );

  return <CompCtx.Provider value={value}>{children}</CompCtx.Provider>;
}

export const useCompetition = () => useContext(CompCtx);
